/**
 * Config Strip Utilities
 *
 * Shared components and constants for ReviewConfigStrip.
 * Extracted for maintainability and reusability.
 */
import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/** Reusable config item wrapper - label stacked above control */
export const ConfigItem = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div className="flex flex-col gap-0.5">
    <span className="text-[11px] font-medium text-zinc-500 dark:text-zinc-400">
      {label}
    </span>
    <div className="flex flex-col gap-1.5">{children}</div>
  </div>
);

/** Checkbox with label */
export const Checkbox = ({
  id,
  checked,
  onChange,
  disabled,
  label,
}: {
  id: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  label: string;
}) => (
  <div className="flex items-center gap-1.5">
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={cn(
        'h-3.5 w-3.5 rounded border-zinc-300 dark:border-zinc-600 cursor-pointer',
        'text-indigo-600 focus:ring-indigo-500 focus:ring-offset-0',
        'disabled:opacity-50 disabled:cursor-not-allowed',
      )}
    />
    <label
      htmlFor={id}
      className="text-[11px] text-zinc-500 dark:text-zinc-400 cursor-pointer"
    >
      {label}
    </label>
  </div>
);

/** Divider between config sections */
export const ConfigDivider = () => (
  <div className="self-stretch w-px bg-zinc-200 dark:bg-zinc-700" />
);
